'use client';

import styled from 'styled-components';
import { COLORS } from '@/constants';

export const StatisticsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const StatCard = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid ${COLORS['neutral/300']};
  height: 100%;
  box-sizing: border-box;
`;

export const StatIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  color: ${COLORS['secondary/500']};
`;

export const StatValue = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS['neutral/700']};
`;

export const RegionsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const StatContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const StatLabel = styled.div`
  font-size: 14px;
  color: ${COLORS['primary/900']};
`;

export const ShowMoreLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS['secondary/500']};

  &:hover {
    text-decoration: underline;
  }
`;
